<template>
  <v-row>
    <v-col cols="12">
      <v-skeleton-loader
        ref="skeleton"
        v-if="!showPage"
        type="card"
        class="mx-auto"
      ></v-skeleton-loader>
      <v-row dense align="center" v-if="showPage">
        <v-col cols="12">
          <v-row>
            <v-col cols="3">
              <h3>{{ form.domain }}</h3>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                dense
                label="EPP Code"
                v-model="form.epp"
                :append-icon="showEpp ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="showEpp ? 'text' : 'password'"
                @click:append="showEpp = !showEpp"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <h5>Registrant Contact</h5>
              <v-row dense>
                <v-col cols="12">
                  <v-btn
                    v-if="defaultContact"
                    x-small
                    color="success"
                    @click="copyContact('defaultContact', 'registrant')">
                    Use default contact</v-btn>
                  <v-btn
                    v-if="typeof $store.state.user.auth_token !== 'undefined'
                    && $store.state.user.auth_token !== null"
                    x-small
                    color="success"
                    @click="copyContact('profile', 'registrant')">Use profile</v-btn>
                  <v-btn
                    v-if="typeof $store.state.user.auth_token !== 'undefined'
                    && $store.state.user.auth_token !== null"
                    x-small
                    color="warning"
                    @click="clearContact('registrant')">Clear</v-btn>
                </v-col>
              </v-row>
              <component
                v-bind:is="registrantComponent"
                ref="registrantProfileComp"
                :forceOrg="forceOrgAdmin"
                :setNewProfile="registrant"
              ></component>
            </v-col>
          </v-row>
          <v-col class="text-right">
            <v-btn
              text-align="right"
              color="primary"
              @click="transfer()"
              :disabled="transferDisabled && !transferProcessing"
              :loading="transferProcessing"
            >Transfer</v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Profile from '../../components/Profile.vue';
import ProfileSg from '../../components/ProfileSg.vue';

export default {
  name: 'Detail',
  components: {
    Profile,
    ProfileSg,
  },
  created() {
    this.id = this.$route.params.id;
    this.$api.get('partner/domain/default-contact').then((response) => {
      const { profile } = response.data;

      if (typeof this.$store.state.user.auth_token !== 'undefined'
        && this.$store.state.user.auth_token !== null) {
        if (profile && !this.$underscore.isEmpty(profile.email)) {
          this.defaultContact = profile;
        }
      }
    });
    this.reloadDomain();
  },
  data() {
    return {
      id: null,
      showPage: false,
      epp: null,
      form: {
        domain: '',
        product_id: null,
        product_term: null,
        status_name: '',
        tld: null,
        epp: null,
        registrant: {},
      },
      showEpp: false,
      currentContactMethod: 'defaultContact',
      defaultContact: null,
      registrantComponent: Profile,
      transferProcessing: false,
      transferDisabled: false,
      registrant: null,
      valid: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
        domain: (value) => (/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?/i).test(value) || 'This field must be valid domain name.',
        childNs: (value) => (/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i).test(`${value}.${this.form.domain}`) || this.$underscore.isEmpty(value) || 'This field must be valid hostname.',
        nameserver: (value) => (/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i).test(value) || this.$underscore.isEmpty(value) || 'This field must be valid hostname.',
        ip: (value) => (/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/).test(value) || 'This field must be valid IP.',
      },
    };
  },
  methods: {
    reloadDomain() {
      this.$api.get(`partner/domain/${this.$route.params.id}`).then((response) => {
        const domainData = response.data;
        if (parseInt(domainData.service_status_id, 0) !== 25) {
          this.$router.push({ name: 'Retail.DomainList' });
        }
        this.form.domain = domainData.service_identity;
        this.form.product_id = domainData.product_id;
        this.showPage = true;
        this.form.tld = domainData.domain_config.product_configuration.tld;
        if (this.form.tld === 'com.sg' || this.form.tld === 'org.sg' || this.form.tld === 'edu.sg') {
          this.forceOrgAdmin = true;
        }
        if (this.form.tld === 'sg' || this.form.tld === 'com.sg' || this.form.tld === 'org.sg' || this.form.tld === 'edu.sg') {
          this.registrantComponent = ProfileSg;
        }
      });
    },
    copyContact(from, to) {
      if (this.currentContactMethod !== from) {
        this.currentContactMethod = from;
      }

      if (from === 'defaultContact') {
        this[to] = this.defaultContact;
        const sgTld = [
          'sg',
          'com.sg',
          'org.sg',
          'edu.sg',
        ];
        if (sgTld.indexOf(this.form.tld) >= 0) {
          if (this.$underscore.isEmpty(this.defaultContact.corporate_no)) {
            this[to].special_field1 = 'p';
            this[to].special_field2 = this.defaultContact.personal_identity_no;
          } else {
            this[to].special_field1 = 'o';
            this[to].special_field2 = this.defaultContact.corporate_no;
          }
        }
      } else if (from === 'profile') {
        this.$api.get('partner/profile').then((response) => {
          this[to] = {};
          const sgTld = [
            'com.sg',
            'org.sg',
            'edu.sg',
          ];
          const auTld = [
            'com.au',
            'org.au',
            'net.au',
          ];
          if (sgTld.indexOf(this.tld_value) >= 0 || auTld.indexOf(this.tld_value) >= 0) {
            this[to].special_field1 = 'o';
          } else {
            this[to].special_field1 = 'p';
          }
          this[to].first_name = response.data.first_name;
          this[to].last_name = response.data.last_name;
          this[to].company_name = response.data.company_name;
          this[to].email = response.data.email;
          this[to].address1 = response.data.address1;
          this[to].city = response.data.city;
          this[to].state = response.data.state;
          this[to].country = response.data.country;
          this[to].postal_code = response.data.postal_code;
          this[to].phone = response.data.phone;
          this[to].phone_country_code = response.data.phone_country_code;
        });
      } else {
        this[to] = this.$refs[`${from}ProfileComp`].getProfileData();
      }
    },
    clearContact(to) {
      this[to] = {
        first_name: '',
        last_name: '',
        email: '',
        company_name: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: 'SG',
        postal_code: '',
        phone_country_code: '',
        phone: '',
        fax_country_code: '',
        fax: '',
        special_field1: 'p',
        special_field2: '',
      };
      const sgTld = [
        'com.sg',
        'org.sg',
        'edu.sg',
      ];
      const auTld = [
        'com.au',
        'org.au',
        'net.au',
      ];
      if (sgTld.indexOf(this.tld_value) >= 0 || auTld.indexOf(this.tld_value) >= 0) {
        this[to].special_field1 = 'o';
      }
    },
    reset() {
      this.$router.go(0);
    },
    transfer() {
      this.transferProcessing = true;
      this.$api.post(`partner/domain/${this.$route.params.id}/transfer`, {
        epp: this.form.epp,
        registrant: this.$refs.registrantProfileComp.getProfileData(),
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Domain transfer is successfully initiated.',
        });
        this.reset();
      }).catch((error) => {
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        }
      }).finally(() => {
        this.transferProcessing = false;
      });
    },
  },
  watch: {
    'form.domain': {
      handler(domain) {
        if (this.rules.domain(domain) !== true) {
          this.checkDomainInvalid = true;
        } else {
          this.checkDomainInvalid = false;
          this.domainErr = null;
        }
      },
    },
  },
};
</script>
